import { render, staticRenderFns } from "./PlayerItemPage.vue?vue&type=template&id=13f3ad16&"
import script from "./PlayerItemPage.vue?vue&type=script&lang=js&"
export * from "./PlayerItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports